import{styled as e}from"@mui/material/styles";const i=e("div")((({theme:e})=>({display:"flex",gap:e.spacing(3)})));export{i as DownloadButtonsWrapper};
//# sourceMappingURL=styles.js.map
